module.exports = __webpack_public_path__ + "media/images/city_img/s_1-55b4e709b7224526f204ab13a91153e9.png";